/**
 * Config object that contains the percentage difference for each sales teams
 */
const config = {
  "Las Vegas Sales Team": 0.05,
};

/**
 * Determines if the usage range should be shown
 *
 * @param {string} team - The sales team
 * @returns {boolean} True if the usage range should be shown
 */
export function shouldShowProductionRange(team) {
  return !!config[team];
}

/**
 * Returns a range of production values based on the usage config
 *
 * @param {number[]} production - The production values
 * @param {string} team - The sales team (used to determine the percentage difference)
 * @returns {number[][]} The range of production values
 */
export function getAnnualProductionRange(production, team) {
  if (!!config[team]) {
    let low = [];
    let high = [];

    production.forEach((prod) => {
      low.push(Math.round(prod - prod * config[team]));
      high.push(Math.round(prod + prod * config[team]));
    });

    return [low, high];
  }

  return null;
}

/**
 * Returns a string of the annual production values
 *
 * @param {number} production - The production value
 * @param {string} team - The sales team (used to determine the percentage difference)
 * @returns {string} The production range or just the production value if team is not in the usage config
 */
export function getAnnualProductionString(production, team) {
  if (!!config[team]) {
    const low = Math.round(
      production - production * config[team]
    ).toLocaleString(undefined);
    const high = Math.round(
      production + production * config[team]
    ).toLocaleString(undefined);

    return `${low} - ${high}`;
  }

  return `${production.toLocaleString(undefined)}`;
}
